<template>
  <div class="hot-list-page">    
    <div class="row hot-company-event">
      <hot-list-companies v-loading="isAShareLoading" @change="aShareHotTabChange" :data="aShareHotCompanyData" :title="'A股热门公司'" class="hot-list-companies"></hot-list-companies>
      <hot-list-companies v-loading="isHongKongStocksLoading" @change="hongKongStocksTabChange" :data="hongKongStocksCompanyData" :title="'港股热门公司'"></hot-list-companies>
    </div>
    <div class="row hot-company-event hot-company-event-bottom">
      <hot-list-companies v-loading="isAmericanStockMarketLoading" @change="americanStockMarketTabChange" :data="americanStockMarketHotCompanyData" :title="'美股热门公司'" class="hot-list-companies"></hot-list-companies>
      <hot-list-companies v-loading="isAllHotCompanyLoading" @change="allTabChange" :data="allHotCompanyData" :title="'全部热门公司'"></hot-list-companies>
    </div>
  </div>
</template>

<script>
import HotListCompanies from '@/components/HotList/HotListCompanies';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      isAShareLoading: false,
      isHongKongStocksLoading: false,
      isAmericanStockMarketLoading: false,
      isAllHotCompanyLoading: false,
      aShareHotCompanyData: [],
      hongKongStocksCompanyData: [],
      americanStockMarketHotCompanyData: [],
      allHotCompanyData: [],
      aShareSentiment: '不限正负',
      hongKongStocksSentiment: '不限正负',
      americanStockMarketSentiment: '不限正负',
      allSentiment: '不限正负'
    };
  },
  methods: {
    americanStockMarketTabChange(item) {
      this.americanStockMarketSentiment = item;
      this.getAmericanStockMarketHotCompany();
    },
    hongKongStocksTabChange(item) {
      this.hongKongStocksSentiment = item;
      this.getHongKongStocksHotCompany();
    },
    aShareHotTabChange(item) {
      this.aShareSentiment = item;
      this.getAShareHotCompany();
    },
    allTabChange(item) {
      this.allSentiment = item;
      this.getAllHotCompany();
    },

    getAShareHotCompany() {
      this.isAShareLoading = true;
      QuestionQuery.getRankCompany('A股', this.aShareSentiment).then(res => {
        this.isAShareLoading = false;
        this.aShareHotCompanyData = res;
      });
    },
    getHongKongStocksHotCompany() {
      this.isHongKongStocksLoading = true;
      QuestionQuery.getRankCompany('港股', this.hongKongStocksSentiment).then(res => {
        this.isHongKongStocksLoading = false;
        this.hongKongStocksCompanyData = res;
      });
    },
    getAmericanStockMarketHotCompany() {
      this.isAmericanStockMarketLoading = true;
      QuestionQuery.getRankCompany('美股', this.americanStockMarketSentiment).then(res => {
        this.isAmericanStockMarketLoading = false;
        this.americanStockMarketHotCompanyData = res;
      });
    },
    getAllHotCompany() {
      this.isAllHotCompanyLoading = true;
      QuestionQuery.getRankCompany('全部', this.allSentiment).then(res => {
        this.isAllHotCompanyLoading = false;
        this.allHotCompanyData = res;
      });
    }
  },
  components: {
    HotListCompanies
  },
  mounted() {
    this.getAShareHotCompany();
    this.getHongKongStocksHotCompany();
    this.getAmericanStockMarketHotCompany();
    this.getAllHotCompany();
  }
};
</script>

<style lang="scss" scoped>
  .hot-list-page {
    width: 1200px;
    min-height: calc(100vh - 59px);
    margin: 0 auto;
    padding-bottom: 16px;
    .hot-company-event {
      margin-top: 16px;
      width: 100%;
      height: 450px;
      .hot-list-companies {
        width: 592px;
        margin-right: 16px;
      }
    }
    .hot-company-event-bottom {
      margin-top: 32px;
    }
    .hot-industry-theme {
      width: 100%;
      height: calc(50vh - 89px);
      .hot-list-industry {
        margin-right: 16px;
      }
    }
  }
</style>

